<app-uni-page
  [parent]="this"
  pageTitle="End of Day: Manifest Groups"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
></app-uni-page>

<ng-template #bodyTemplate>
  <uni-qb-health-banner></uni-qb-health-banner>
  <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex h-full w-full flex-col">
        <app-ag-grid [gridOptions]="manifestGroupGridOptions"></app-ag-grid>
        <ng-template #invoiceScheduleCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" *ngIf="row?.manifest?.rRule != null" (click)="viewEventSchedule(row)">
            View
          </button>
        </ng-template>
        <ng-template #sendManifestCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" [disabled]="!canSendManifest(row)" (click)="sendManifest(row)">
            Print/Send Manifest
          </button>
        </ng-template>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex h-full w-full flex-col">
        <div class="px-2 py-1 font-semibold text-sm">Submitted Manifest Groups</div>
        <app-ag-grid [gridOptions]="submittedGroupGridOptions"></app-ag-grid>
        <ng-template #viewManifestCell let-row>
          <button pButton type="button" class="p-button-text p-button-sm" (click)="viewManifest(row)">View Manifest</button>
        </ng-template>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
